// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const braixen: PokeData = {
  "id": 654,
  "name": "braixen",
  "height": 10,
  "weight": 145,
  "base_experience": 143,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "scratch",
    "tail-whip",
    "ember",
    "flamethrower",
    "psybeam",
    "fire-spin",
    "psychic",
    "light-screen",
    "fire-blast",
    "sunny-day",
    "will-o-wisp",
    "howl",
    "lucky-chant",
    "psyshock",
    "magic-room",
    "flame-charge"
  ],
  "moves": [
    "scratch",
    "ember",
    "flamethrower",
    "fire-spin",
    "psychic",
    "sunny-day",
    "eruption",
    "flare-blitz",
    "fire-ball",
    "morning-sun",
    "magma-storm",
    "fire-punch",
    "fire-fang"
  ],
  "evolution_chain": {
    "id": 338,
    "item": null,
    "species": [
      {
        "name": "fennekin",
        "order": 654,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "braixen",
        "order": 655,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 653,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "delphox",
        "order": 656,
        "types": [
          PokeType.FIRE,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 654,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.5,
    "speed": 73,
    "ability_power": 90
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
